import { render, staticRenderFns } from "./listasset.vue?vue&type=template&id=354fe8a2&scoped=true"
import script from "./listasset.vue?vue&type=script&lang=js"
export * from "./listasset.vue?vue&type=script&lang=js"
import style0 from "./listasset.vue?vue&type=style&index=0&id=354fe8a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fe8a2",
  null
  
)

export default component.exports